import type { ReactNode } from "react";
import type { CommuneAssocieeDeleguee } from "models";
import { Link, Skeleton, Tooltip } from "@mui/material";
import { COLLECTIVITES_APP_DOMAIN_NAME } from "config/app-config";

interface CommuneAssocieeDelegueeLinkProps {
  communeAssocieeDeleguee: CommuneAssocieeDeleguee;
  isLoading?: boolean;
}

export function CommuneAssocieeDelegueeLink({
  communeAssocieeDeleguee,
  isLoading = false,
}: Readonly<CommuneAssocieeDelegueeLinkProps>): ReactNode {
  if (isLoading) {
    return <Skeleton />;
  }

  return (
    <Tooltip title="Commune associée déléguée">
      <Link
        key={communeAssocieeDeleguee.id}
        target="_blank"
        href={`https://${COLLECTIVITES_APP_DOMAIN_NAME}/commune-associee-deleguee/${communeAssocieeDeleguee.id}`}
        sx={{ fontStyle: "italic" }}>
        {communeAssocieeDeleguee.libelle}
      </Link>
    </Tooltip>
  );
}
